var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tw:flex tw:flex-col tw:gap-4 tw:typography-small tw:text-secondary"},_vm._l((_setup.fields),function(field){return _c('div',{key:field.key},[_c('div',{staticClass:"tw:typography-h3 tw:text-main"},[_vm._v(_vm._s(field.label))]),_c('div',{staticClass:"tw:mt-2"},[_vm._v(_vm._s(field.value))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }